import { gql } from "shared/lib/graphql"

export const SubscriptionUpdateMutation = gql`
  mutation($product_id: String!) {
    userSubscriptionUpdate(input: { product_id: $product_id }) {
      user_subscription {
        plan_id
      }
      errors {
        attribute
        message
      }
    }
  }
`
